module.exports = __webpack_public_path__ + "static/media/xuanchuan.7c070975.mp4";